<template>
  <Adminlte>
    Welcome Admin!
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
export default {
  name: 'AdminHome',
  components: { Adminlte }
}
</script>



// WEBPACK FOOTER //
// Home.vue?7c164b94